module.exports = __webpack_public_path__ + "img/polar-logo.52940f8c.jpg";